<template>
  <span
    :class="[starIcon]"
  />
</template>

<script lang="ts">

export default defineComponent({
  name: 'ReviewStar',
  props: {
    rating: {
      type: Number,
      required: true,
    },
    selectedRating: {
      type: Number,
      default: null,
    },
    hoverRating: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {

    const starIcon = computed(() =>
      props.rating <= props.hoverRating || props.rating <= props.selectedRating
        ? 'iconify svg--star'
        : 'iconify svg--star-empty',
    );

    return {
      starIcon,
    };
  
  },
});

</script>
